import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GraphNodeTypes } from '../services/ducks/designerDuck/designerDuck';
import {
  WorkflowStateNode,
  startNodeSelector,
  parentIDSelector,
  layerMapSelector,
  removeNode,
  nodesSelector,
} from '../services/ducks/workflowDuck/workflowDuck';

export const useCanNodeBeDeleted = (
  id: WorkflowStateNode['id'],
  type: GraphNodeTypes
) => {
  const startNode = useSelector(startNodeSelector);
  const parentIDs = useSelector(parentIDSelector(id));
  const storedNodes = useSelector(nodesSelector);
  const layerMap = useSelector(layerMapSelector);

  return useMemo(() => {
    if (id === startNode) {
      const { nodes } = removeNode({
        id,
        type,
        start: startNode,
        layerMap,
        parentIDs: [...parentIDs],
        nodes: storedNodes,
      });

      for (const nodeId in nodes) {
        const allowedTypes = {
          [GraphNodeTypes.STATE]: true,
          [GraphNodeTypes.JUNCTION]: true,
          [GraphNodeTypes.CHILD]: true,
          [GraphNodeTypes.MODULE]: false,
          [GraphNodeTypes.GROUP_JUNCTION]: false,
          [GraphNodeTypes.GROUP_EXIT]: false,
          [GraphNodeTypes.TRIGGER]: false,
        };
        if (allowedTypes[nodes[nodeId].type]) {
          return true;
        }
      }
    } else {
      return true;
    }
    return false;
  }, [id, layerMap, parentIDs, startNode, storedNodes, type]);
};
